<template>
  <div class="spl-parcel-detail-block-scans">
    <div class="spl-parcel-detail-block-scans__label">
      {{ label }}
    </div>
    <div class="spl-parcel-detail-block-scans__body">
      <!-- *********************** Block for static fields *********************************** -->
      <div
        v-for="(item, index) in blockContent"
        :key="'parcelDetailScans' + index"
        class="spl-parcel-detail-block-scans__body__content">
        <div class="spl-parcel-detail-block-scans__body__content__label">
          {{ item.label }}
        </div>
        <div class="spl-parcel-detail-block-scans__body__content__value">
          {{ item.value }}
        </div>
      </div>
      <div class="spl-parcel-detail-block-scans__body__content">
        <div class="spl-parcel-detail-block-scans__body__content__label">
          Forwarder tracking page
        </div>
        <div class="spl-parcel-detail-block-scans__body__content__value">
          <external-tracker :parcel-details="parcelDetails" />
        </div>
      </div>
    </div>
    <!-- *********************** Block with events *********************************** -->
    <h4 style="padding-top: inherit; padding-bottom: inherit;">
      Events
    </h4>
    <form-checkbox v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.SHOW_UPDATE_EVENT)" v-model="updateDetailsExpanded">
      Show Update Details
    </form-checkbox>
    <div ref="scanTable">
      <table
        v-if="userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.LIST) && $mq !== 'sm'"
        border="1"
        cellpadding="0"
        cellspacing="0"
        class="spl-parcel-detail-block-scans__body spl-parcel-detail-block-scans__body-table">
        <thead>
          <tr>
            <th />
            <th>Milestone</th>
            <th>Position</th>
            <th>Timestamp</th>
            <th>Type</th>
            <th>User</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in filteredTableContent"
            :key="'parcelDetailScansTable'+index"
            :class="{'spl-parcel-detail-block-scans__body__row-inactive': !item.active,
                     'spl-parcel-detail-block-scans__body__row-milestone': item.milestone !== '-' && item.active,
                     'spl-parcel-detail-block-scans__body__row-update_details': item.event_info_id === parcel_update_details_event}"
            class="spl-parcel-detail-block-scans__body__row">
            <td>
              <form-checkbox
                :has-margin="true"
                :disabled="item.event_info_id === parcel_update_event || item.event_info_id === parcel_update_details_event"
                :checked="item.selected"
                @checkboxChanged="checkboxChanged(item)" />
            </td>
            <td @click="checkboxChanged(item)">
              {{ item.milestone }}
            </td>
            <td @click="checkboxChanged(item)">
              {{ item.position }}
            </td>
            <td @click="checkboxChanged(item)">
              {{ item.timestamp }}
            </td>
            <td @click="checkboxChanged(item)">
              {{ item.type }}
            </td>
            <td @click="checkboxChanged(item)">
              {{ item.user }}
            </td>
            <td
              :data-text="item.note"
              :class="{'table-hover-tooltip': item.note.length > 30}"
              @click="checkboxChanged(item)">{{ item.note }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="$mq === 'sm'" class="spl-parcel-detail-block-scans__body">
      <div
        v-for="(item, index) in filteredTableContent"
        :key="'parcelDetailScansTable'+index"
        :class="{'spl-parcel-detail-block-scans__body__row-inactive': !item.active,
                 'spl-parcel-detail-block-scans__body__row-milestone': item.milestone !== '-' && item.active,
                 'spl-parcel-detail-block-scans__body__row-update_details': item.event_info_id === parcel_update_details_event}"
        class="spl-parcel-detail-block-scans__body__row">
        <div class="spl-parcel-detail-block-scans__body__row__checkbox">
          <form-checkbox
            :has-margin="true"
            :disabled="item.event_info_id === parcel_update_event || item.event_info_id === parcel_update_details_event"
            :checked="item.selected"
            @checkboxChanged="checkboxChanged(item)">{{ item.position }}</form-checkbox>
        </div>
        <div class="spl-parcel-detail-block-scans__body__row__column">
          <span>Milestone:</span>{{ item.milestone }}
        </div>
        <div class="spl-parcel-detail-block-scans__body__row__column">
          <span>Position:</span>{{ item.position }}
        </div>
        <div class="spl-parcel-detail-block-scans__body__row__column">
          <span>Timestamp:</span>{{ item.timestamp }}
        </div>
        <div class="spl-parcel-detail-block-scans__body__row__column">
          <span>Type:</span>{{ item.type }}
        </div>
        <div class="spl-parcel-detail-block-scans__body__row__column">
          <span>User:</span>{{ item.user }}
        </div>
        <div class="spl-parcel-detail-block-scans__body__row__column">
          <span>Note:</span>{{ item.note }}
        </div>
      </div>
    </div>
    <scan-parcels-modal
      :update-event="update_item"
      :selected-rows="update_parcel"
      @parcelScanned="eventUpdated"
      @event_updated="eventUpdated" />
    <div
      v-if="userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.DELETE)"
      class="spl-parcel-detail-block-scans__function-button"
      @click="deactivateScans">
      Deactivate Scans
    </div>
    <div
      v-if="userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.CREATE)"
      class="spl-parcel-detail-block-scans__function-button"
      @click="activateScans">
      Activate Scans
    </div>
    <div
      v-if="userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.UPDATE)"
      class="spl-parcel-detail-block-scans__function-button"
      @click="openUpdateScanModal">
      Update Scans
    </div>
    <div
      v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.SCAN)"
      class="spl-parcel-detail-block-scans__function-button"
      @click="openNewScanModal">
      New Scan
    </div>
    <div
      v-if="$mq !== 'sm'"
      class="spl-parcel-detail-block-scans__function-button"
      @click="copyTable">
      Copy Table
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import constants from '@/constants'
import webApi from '@/webApi'
import { filter } from 'lodash'
export default {
  name: 'ParcelDetailBlockScans',
  mixins: [Helpers],
  props: [
    'label',
    'content',
    'table',
    'parcelKey',
    'parcelDetails'
  ],
  data () {
    return {
      hide_event: constants.EVENT_INFO_ID.PARCEL_UPDATE_DETAILS,
      parcel_update_details_event: constants.EVENT_INFO_ID.PARCEL_UPDATE_DETAILS,
      parcel_update_event: constants.EVENT_INFO_ID.PARCEL_UPDATE,
      updateDetailsExpanded: false,
      update_item: {},
      update_parcel: [{ Parcel_ID: this.parcelKey }],
      constants
    }
  },
  computed: {
    tableContent () {
      return this.table
    },
    filteredTableContent () {
      return filter(this.tableContent, (item) => {
        return item.event_info_id !== this.hide_event
      })
    },
    blockContent () {
      return this.content
    }
  },
  watch: {
    updateDetailsExpanded (newValue) {
      this.hide_event = newValue ? '' : constants.EVENT_INFO_ID.PARCEL_UPDATE_DETAILS
    }
  },
  methods: {
    // ************************ Open the update scan modal ************************
    openUpdateScanModal () {
      // Updates are only allowed on one  event
      if (this.tableContent.filter((item) => { return item.selected }).length === 1) {
        this.update_item = this.tableContent.filter((item) => { return item.selected })[0]
        window.bus.$emit('openScanParcelsModal')
      } else {
        window.bus.$emit('openErrorModal', 'Please select a singular scan to update.')
      }
    },
    // ************************ Open the new scan modal ************************
    openNewScanModal () {
      // New
      this.update_item = {
        position: 'Delivered',
        event_info_id: constants.EVENT_INFO_ID.DELIVERED,
        timestamp: new Date().toISOString().substring(0, 10) + ' 00:00',
        note: '',
        signed: ''
      }

      window.bus.$emit('openScanParcelsModal')
    },
    // ************************ Activate a scan ************************
    activateScans () {
      var eventIdList = []
      this.tableContent.filter((item) => { return item.selected }).forEach((item) => {
        eventIdList.push(item.event_id)
      })
      // TODO why are we stringify the array?
      webApi.event.activate_Event(eventIdList)
        .then((response) => {
        // Update all the items in the  frontend
          var alreadyActiveEvents = ' '
          this.tableContent.filter((item) => { return item.selected }).forEach((item) => {
            var updatedEvents = response.data
            if (updatedEvents.indexOf(item.event_id) > -1) {
              item.active = true
              item.selected = false
            } else {
              alreadyActiveEvents += " '" + item.position + "'"
            }
          })
          if (alreadyActiveEvents !== ' ') {
            window.bus.$emit('openErrorModal', 'These Events were already active:' + alreadyActiveEvents)
          }
          this.$emit('parcelUpdated')
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },
    // ************************ Deactivate a scan ************************
    deactivateScans () {
      var eventIdList = []
      this.tableContent.filter((item) => { return item.selected }).forEach((item) => {
        eventIdList.push(item.event_id)
      })
      webApi.event.deactivate_Event(eventIdList)
        .then((response) => {
        // Update all the items in the  frontend
          var alreadyInactiveEvents = ' '
          this.tableContent.filter((item) => { return item.selected }).forEach((item) => {
            var updatedEvents = response.data
            if (updatedEvents.indexOf(item.event_id) > -1) {
              item.active = false
              item.selected = false
            } else {
              alreadyInactiveEvents += " '" + item.position + "'"
            }
          })
          if (alreadyInactiveEvents !== ' ') {
            window.bus.$emit('openErrorModal', 'These Events were already inactive:' + alreadyInactiveEvents)
          }
          this.$emit('parcelUpdated')
        }).catch((response) => {
          this.$emit('parcelUpdated')
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },
    // ************************Called when an event was updated ************************
    eventUpdated () {
      this.$emit('parcelUpdated')
    },
    // ************************ Handles checkbox changes ************************
    checkboxChanged (item) {
      if (item.event_info_id === this.parcel_update_event || item.event_info_id === this.parcel_update_details_event) {
        return
      }
      var foundEvents = filter(this.tableContent, { event_id: item.event_id })
      if (foundEvents.length === 1) {
        foundEvents[0].selected = !foundEvents[0].selected
      }
    },
    copyTable () {
      window.addEventListener('copy', (event) => {
        event.preventDefault()
        event.clipboardData.setData('text/html', this.$refs.scanTable.innerHTML)
      })
      document.execCommand('copy')
    }
  }

}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-detail-block-scans {
        background-color: $parcelTimelineBackgroundColor;
        margin-bottom: 20px;
        padding: 20px 17px 30px 17px;
        position: relative;
        width: 100%;

        &__contract,
        &__expand {
            background-position: center center;
            background-repeat: no-repeat;
            border: 2px solid $parcelListControlsBorderColor;
            border-radius: 50%;
            cursor: pointer;
            float: right;
            height: 25px;
            margin-left: 0px;
            width: 25px;
            background-color: $grey_70;

            &-active {
                background-color: $mainTextColor;
            }
        }
        &__contract {
            background-image: url(../../assets/icon-contract.svg);

            &-active {
                background-image: url(../../assets/icon-contract-active.svg);
            }
        }
        &__expand {
            background-image: url(../../assets/icon-expand.svg);

            &-active {
                background-image: url(../../assets/icon-expand-active.svg);
            }
        }
        &__label {
            color: $mainInputColor;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 15px;
        }
        &__body {
          width: -webkit-fill-available;
          border-collapse: collapse;
          margin-top: 10px;
          thead {
            th {
              text-align: left;
              font-family: $mono;
              font-size: 9px;
              font-weight: 700;
              text-transform: uppercase;
              letter-spacing: 1px;
              line-height: 12px;
              padding: 5px;
              height: 20px;
              z-index: 2;
              border: 1px solid $tableHeaderBorderColor;
              background-color: $middleYellow
            }
          }
          tbody {
            td {
              border-style: solid;
              border-width: 1px;
              border-color: $tableRowBorderLowColor;
              font-size: 12px;
              padding: 4px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 150px;
              & span {
                display: none;
              }
            }
            tr:hover {
              background-color: $tableRowBackgroundColorHover;
            }
            td:hover {
              cursor: pointer;
            }

            .table-hover-tooltip:focus:after, .table-hover-tooltip:hover:after{
              content:attr(data-text);
              overflow: visible;
              text-overflow: inherit;
              background: #fff;
              position: absolute;
              left:auto;
              top:auto;
              width: auto;
              max-width: 20rem;
              border: 1px solid #eaebec;
              padding: 0 .5rem;
              box-shadow: 0 2px 4px 0 rgba(0,0,0,.28);
              white-space: normal;
              word-wrap: break-word;
              display:block;
              color:black;
              margin-top:-1.25rem;
            }

          }
            &__content {
                font-size: 12px;
                line-height: 1.7;

                &:after {
                    clear: both;
                    content: '';
                    display: block;
                    float: none;
                }
                &-blocks,
                &__label,
                &__value {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;
                    width: 50%;
                }
                &__value {
                    font-weight: 600;
                    white-space: pre;
                }
            }
            &__row-inactive {
              & td {
                color: $disabledYellow;
                text-decoration:line-through;
              }
            }
            &__row-milestone {
              & td {
                font-weight: bold;
              }
            }
            &__row-update_details{
              & td {
                color: $grey_60;
              }
            }
            &__row:nth-child(even) {
                background-color: $parcelDetailBlockLogRowColor;
            }
        }
        &__function-button {
            color: $middleYellow;
            cursor: pointer;
            display: inline-block;
            font-size: 12px;
            font-weight: 600;
            margin-top: 15px;
            margin-right: 20px;
            transition: color $shortTransition ease-in-out;

            @include mobile() {
                margin-right: 10px;
            }
            &:hover {
                color: $yellowButtonLabelHover;
            }
        }
        &__highlight {
            background-color: $parcelDetailBlockLogRowColor;
            border-left: 2px solid $parcelDetailBlockGreyHighlightColor;
            bottom: 0;
            color: $mainInputColor;
            font-size: 12px;
            font-weight: 400;
            margin: 15px -17px -30px -17px;
            padding: 15px;
        }
    }
@include mobile() {
  .spl-parcel-detail-block-scans {
    &__body {
      &__row {
        & span {
          display: inline;
          margin-right: 10px;
          font-style: italic;
        }
        &__checkbox {
            float: none;
            padding-left: 5px;
            width: auto;
        }
        &__column {
          text-decoration:inherit;
          font-size: 12px;
          float: none;
          display: block;
          line-height: auto;
          min-height: none;
          padding-left: 5px;
          &-select,
          &-milestone,
          &-postion,
          &-timestamp,
          &-type,
          &-user,
          &-note {
              width: auto;
          }
        }
      }
    }
    &__expand,
    &__contract {
      display: none;
    }
  }
}
</style>
